export { default } from './ModelsSlider';
